<template>
    <squad-form v-if="squad" :squad="squad"></squad-form>
</template>

<script>
    import axios from 'axios';
    import SquadForm from '../components/SquadForm'
    export default {
        name: 'squad-edit',
        data () {
            return {
                squad: false
            }
        },
        components: {
            SquadForm
        },
        mounted() {
            axios
                .get('/api/squads/' + this.$route.params.id)
                .then((response) => {
                    this.squad = response.data.data
                })
        }
    }
</script>
